"use strict";
var distill;
(function (distill) {
    var datasets;
    (function (datasets) {
        var views;
        (function (views) {
            var settings;
            (function (settings) {
                class InitArgs {
                    constructor() {
                        this.existingColumns = [];
                        this.datasetId = appn.emptyString;
                        this.columnTypes = [];
                        this.isCruxSource = false;
                        this.isCreateMode = false;
                        this.originalPrimaryKeyIds = [];
                        this.columnIdsInUse = [];
                        this.orphanedColumnIds = [];
                        this.availableNewColumns = null;
                    }
                }
                let _initArgs;
                let _columnBuilder;
                let _originalColumns = [];
                let $mainForm = $();
                let _availableNewColumns = null;
                function init(args) {
                    _initArgs = args;
                    _originalColumns = JSON.parse(JSON.stringify(_initArgs.existingColumns || []));
                    views.setColumnTypes(_initArgs.columnTypes);
                    $(function () {
                        $mainForm = $('form[action*="Datasets/Settings"]:first');
                        bindEvents();
                    });
                }
                settings.init = init;
                function bindEvents() {
                    var _a;
                    if (((_a = _initArgs.orphanedColumnIds) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                        _initArgs.existingColumns.forEach(col => {
                            if (_initArgs.orphanedColumnIds.includes(col.id))
                                col.isOrphaned = true;
                        });
                    }
                    const config = {
                        isCruxSource: _initArgs.isCruxSource,
                        isCreateMode: _initArgs.isCreateMode,
                        containerId: 'schemaColumnsList',
                        showPk: true,
                        showType: true,
                        showRequired: true,
                        showUnique: true,
                        allowTypeChanges: !_initArgs.isCruxSource,
                        readonlyRequiredUnique: _initArgs.isCruxSource,
                        originalPrimaryKeyIds: _initArgs.originalPrimaryKeyIds,
                        columnIdsInUse: _initArgs.columnIdsInUse,
                        orphanedColumnIds: _initArgs.orphanedColumnIds,
                        onChanged: () => {
                            views.ColumnBuilder.refreshIndexes([{ builder: _columnBuilder }]);
                        }
                    };
                    _columnBuilder = new views.ColumnBuilder(_initArgs.existingColumns, config);
                    $('#addColumnBtn').off('click').on('click', function () {
                        _columnBuilder.addColumn();
                    });
                    $('#includeCruxColumnsBtn').off('click').on('click', function () {
                        openIncludeCruxColumnsModal();
                    });
                    $('#confirmIncludeCruxColumns').off('click').on('click', function () {
                        confirmIncludeCruxColumns();
                    });
                    $(document).off('click', '.delete-column-btn').on('click', '.delete-column-btn', function (e) {
                        e.preventDefault();
                        const columnId = $(e.currentTarget).data('column-id');
                        _columnBuilder.deleteColumn(columnId);
                    });
                    const $trashBtn = $('nav .navbar-nav-right button[value*="Trash"]');
                    if ($trashBtn.length > 0)
                        distill.trash.addTrashMessage($trashBtn, '#Name', undefined, undefined, false);
                    $('#saveButton').off('click').on('click', function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        views.ColumnBuilder.refreshIndexes([{ builder: _columnBuilder }]);
                        if (!$mainForm.valid()) {
                            const $firstError = $('.field-validation-error:visible').first();
                            if ($firstError.length)
                                $firstError[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
                            return false;
                        }
                        const changeSummary = getDetailedChangeSummary();
                        if (changeSummary.hasChanges) {
                            displaySchemaChangeModal(changeSummary);
                            return false;
                        }
                        else
                            $mainForm[0].submit();
                    });
                    $('#confirmSchemaChanges').off('click').on('click', function () {
                        $mainForm.find('input[name="hasColumnChanges"]').remove();
                        $('<input type="hidden" name="hasColumnChanges" value="true">').appendTo($mainForm);
                        $('#schemaChangeModal').modal('hide');
                        $mainForm[0].submit();
                    });
                }
                function getCurrentColumnsFromDOM() {
                    const columns = [];
                    $('#schemaColumnsList tbody tr').each(function (index) {
                        var _a, _b, _c, _d;
                        const $row = $(this);
                        if ($row.hasClass('column-row-excluded'))
                            return;
                        const columnId = ((_a = $row.data('column-id')) === null || _a === void 0 ? void 0 : _a.toString()) || '';
                        if (!columnId)
                            return;
                        const designation = $row.data('designation') || null;
                        const isNew = $row.data('is-new') === true;
                        const displayName = ((_b = $row.find('.column-name').val()) === null || _b === void 0 ? void 0 : _b.toString()) || '';
                        const type = ((_c = $row.find('.column-type').val()) === null || _c === void 0 ? void 0 : _c.toString()) || 'Text';
                        const required = $row.find('.column-required').is(':checked');
                        const unique = $row.find('.column-unique').is(':checked');
                        const defaultValue = ((_d = $row.find('.column-default').val()) === null || _d === void 0 ? void 0 : _d.toString()) || '';
                        const isPrimaryKey = $row.find('.column-pk-hidden').val() === 'true';
                        columns.push({
                            id: columnId,
                            displayName: displayName,
                            type: type,
                            required: required,
                            unique: unique,
                            defaultValue: defaultValue,
                            designation: designation,
                            isPrimaryKey: isPrimaryKey,
                            displayOrder: index + 1,
                            isNew: isNew
                        });
                    });
                    return columns;
                }
                function getDetailedChangeSummary() {
                    const currentColumns = getCurrentColumnsFromDOM();
                    const changes = [];
                    const originalFiltered = _originalColumns.filter(c => c.designation !== 'RowLastUpdated');
                    const currentFiltered = currentColumns.filter(c => c.designation !== 'RowLastUpdated');
                    const originalMap = new Map(originalFiltered.map(c => [c.id, c]));
                    const currentMap = new Map(currentFiltered.map(c => [c.id, c]));
                    const addedIds = Array.from(currentMap.keys()).filter(id => !originalMap.has(id));
                    addedIds.forEach(id => {
                        const col = currentMap.get(id);
                        if (col) {
                            const details = [T('Type') + ': ' + views.getTypeLabel(col.type)];
                            if (col.isPrimaryKey)
                                details.push(T('Primary Key') + ': ' + T('Yes'));
                            changes.push({
                                columnName: col.displayName || T('Unnamed Column'),
                                changeType: 'added',
                                details: details
                            });
                        }
                    });
                    const removedIds = Array.from(originalMap.keys()).filter(id => !currentMap.has(id));
                    removedIds.forEach(id => {
                        const col = originalMap.get(id);
                        if (col && !col.alwaysIncluded && !col.isPrimaryKey) {
                            changes.push({
                                columnName: col.displayName,
                                changeType: 'removed',
                                details: []
                            });
                        }
                    });
                    currentMap.forEach((currentCol, id) => {
                        const originalCol = originalMap.get(id);
                        if (!originalCol)
                            return;
                        const details = [];
                        if (originalCol.displayName !== currentCol.displayName)
                            details.push(T('Name') + ': "' + originalCol.displayName + '" → "' + currentCol.displayName + '"');
                        if (originalCol.type !== currentCol.type) {
                            const oldType = views.getTypeLabel(originalCol.type);
                            const newType = views.getTypeLabel(currentCol.type);
                            details.push(T('Type') + ': ' + oldType + ' → ' + newType);
                        }
                        if (originalCol.required !== currentCol.required)
                            details.push(T('Required') + ': ' + (currentCol.required ? T('Yes') : T('No')));
                        if (originalCol.unique !== currentCol.unique)
                            details.push(T('Unique') + ': ' + (currentCol.unique ? T('Yes') : T('No')));
                        if (originalCol.isPrimaryKey !== currentCol.isPrimaryKey)
                            details.push(T('Primary Key') + ': ' + (currentCol.isPrimaryKey ? T('Yes') : T('No')));
                        const originalDefault = originalCol.defaultValue || '';
                        const currentDefault = currentCol.defaultValue || '';
                        if (originalDefault !== currentDefault) {
                            const oldVal = originalDefault || T('(none)');
                            const newVal = currentDefault || T('(none)');
                            details.push(T('Default Value') + ': "' + oldVal + '" → "' + newVal + '"');
                        }
                        if (details.length > 0) {
                            changes.push({
                                columnName: currentCol.displayName,
                                changeType: 'modified',
                                details: details
                            });
                        }
                    });
                    const hasReorder = function checkOrder(original, current) {
                        if (original.length !== current.length)
                            return false;
                        for (let i = 0; i < original.length; i++) {
                            if (original[i].id !== current[i].id)
                                return true;
                        }
                        return false;
                    }(originalFiltered, currentFiltered);
                    return {
                        hasChanges: changes.length > 0 || hasReorder,
                        changes: changes,
                        hasReorder: hasReorder && changes.length === 0
                    };
                }
                function displaySchemaChangeModal(changeSummary) {
                    let html = '';
                    if (changeSummary.changes.length > 0) {
                        const added = changeSummary.changes.filter(c => c.changeType === 'added');
                        const removed = changeSummary.changes.filter(c => c.changeType === 'removed');
                        const modified = changeSummary.changes.filter(c => c.changeType === 'modified');
                        if (added.length > 0) {
                            html += '<div class="mb-3"><strong class="text-success"><i class="fa fa-plus-circle"></i> ' + T('Added Columns') + ' (' + added.length + '):</strong><ul class="mt-2">';
                            added.forEach(change => {
                                html += '<li><strong>' + change.columnName + '</strong>';
                                if (change.details.length > 0) {
                                    html += '<ul class="text-muted">';
                                    change.details.forEach(detail => {
                                        html += '<li>' + detail + '</li>';
                                    });
                                    html += '</ul>';
                                }
                                html += '</li>';
                            });
                            html += '</ul></div>';
                        }
                        if (removed.length > 0) {
                            html += '<div class="mb-3"><strong class="text-danger"><i class="fa fa-minus-circle"></i> ' + T('Removed Columns') + ' (' + removed.length + '):</strong><ul class="mt-2">';
                            removed.forEach(change => {
                                html += '<li><strong>' + change.columnName + '</strong></li>';
                            });
                            html += '</ul></div>';
                        }
                        if (modified.length > 0) {
                            html += '<div class="mb-3"><strong class="text-primary"><i class="fa fa-edit"></i> ' + T('Modified Columns') + ' (' + modified.length + '):</strong><ul class="mt-2">';
                            modified.forEach(change => {
                                html += '<li><strong>' + change.columnName + '</strong>';
                                if (change.details.length > 0) {
                                    html += '<ul class="text-muted">';
                                    change.details.forEach(detail => {
                                        html += '<li>' + detail + '</li>';
                                    });
                                    html += '</ul>';
                                }
                                html += '</li>';
                            });
                            html += '</ul></div>';
                        }
                    }
                    if (changeSummary.hasReorder)
                        html += '<div class="mb-3"><strong class="text-info"><i class="fa fa-arrows-v"></i> ' + T('Column Order Changed') + '</strong></div>';
                    $('#schemaChangeSummary').html(html);
                    $('#schemaChangeModal').modal('show');
                }
                function openIncludeCruxColumnsModal() {
                    const data = _initArgs.availableNewColumns;
                    if (!data)
                        return;
                    _availableNewColumns = data;
                    if (data.existingColumnOrders) {
                        data.existingColumnOrders.forEach(eco => {
                            const existingCol = _columnBuilder.columns.find(c => c.displayName.toLowerCase() === eco.displayName.toLowerCase());
                            if (existingCol)
                                existingCol.displayOrder = eco.displayOrder;
                        });
                    }
                    populateIncludeCruxColumnSelects(data);
                    $('#includeCruxColumnsModal').modal('show');
                }
                function populateIncludeCruxColumnSelects(data) {
                    const $autoSelect = $('#includeCruxColumnSelectAuto');
                    const $singularSelect = $('#includeCruxColumnSelectSingular');
                    const $repeatSelect = $('#includeCruxColumnSelectRepeat');
                    if ($autoSelect.length)
                        $autoSelect.bootstrapDualListbox('refresh');
                    if ($singularSelect.length)
                        $singularSelect.bootstrapDualListbox('refresh');
                    if ($repeatSelect.length)
                        $repeatSelect.bootstrapDualListbox('refresh');
                    $('#includeCruxColumnsModal .multiselect').off('change').on('change', updateConfirmButton);
                    updateConfirmButton();
                }
                function updateConfirmButton() {
                    const selectedIds = new Set(getSelectedFieldIds());
                    const stagedIds = stagedDialogColumnIds();
                    const hasChanges = stagedIds.some(id => !selectedIds.has(id))
                        || [...selectedIds].some(id => !stagedIds.includes(id));
                    $('#confirmIncludeCruxColumns').prop('disabled', !hasChanges);
                }
                function getSelectedFieldIds() {
                    const auto = $('#includeCruxColumnSelectAuto').val() || [];
                    const singular = $('#includeCruxColumnSelectSingular').val() || [];
                    const repeat = $('#includeCruxColumnSelectRepeat').val() || [];
                    return [...auto, ...singular, ...repeat];
                }
                function confirmIncludeCruxColumns() {
                    const selectedIds = new Set(getSelectedFieldIds());
                    const dialogFields = allAvailableNewFields();
                    const stagedIds = new Set(stagedDialogColumnIds());
                    const toAdd = dialogFields.filter(f => selectedIds.has(f.id) && !stagedIds.has(f.id));
                    const toRemove = [...stagedIds].filter(id => !selectedIds.has(id));
                    toRemove.forEach(id => _columnBuilder.deleteColumn(id));
                    if (toAdd.length > 0) {
                        _columnBuilder.addIncludeCruxColumns(toAdd.map(field => ({
                            id: field.id,
                            fieldName: field.fieldName || field.displayName,
                            displayName: field.displayName,
                            type: field.type || 'Text',
                            required: field.required || false,
                            unique: field.unique || false,
                            defaultValue: field.defaultValue || '',
                            isPrimaryKey: field.isPrimaryKey || false,
                            displayOrder: field.displayOrder || 0,
                            designation: field.designation,
                            columnCategory: field.columnCategory,
                            alwaysIncluded: field.alwaysIncluded !== undefined ? field.alwaysIncluded : !!field.designation,
                            cruxRepeatName: field.cruxRepeatName || '',
                            isNew: true
                        })));
                    }
                    $('#includeCruxColumnsModal').modal('hide');
                    if (toAdd.length > 0)
                        appn.toast.notify(appn.toast.Type.success, T('{0} field(s) added. Review and click Save to apply changes.', toAdd.length));
                }
                function allAvailableNewFields() {
                    return [
                        ...((_availableNewColumns === null || _availableNewColumns === void 0 ? void 0 : _availableNewColumns.autoColumns) || []),
                        ...((_availableNewColumns === null || _availableNewColumns === void 0 ? void 0 : _availableNewColumns.singularFields) || []),
                        ...((_availableNewColumns === null || _availableNewColumns === void 0 ? void 0 : _availableNewColumns.repeatFields) || [])
                    ];
                }
                function stagedDialogColumnIds() {
                    const dialogIds = new Set(allAvailableNewFields().map(f => f.id));
                    return _columnBuilder.columns.filter(c => c.isNew && dialogIds.has(c.id)).map(c => c.id);
                }
            })(settings = views.settings || (views.settings = {}));
        })(views = datasets.views || (datasets.views = {}));
    })(datasets = distill.datasets || (distill.datasets = {}));
})(distill || (distill = {}));
